// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"3baf46f6","412":"f7c78d8c","806":"e34e3394","886":"9d42bf4b"}[chunkId] + ".chunk.css";
};